import { Component } from '@angular/core';
import {DetailScreensService} from '../po-treeview/detail-screens-module/services/detail-screens-service';

@Component({
  selector: 'app-customer-contribution',
  templateUrl: './customer-contribution.component.html',
  styleUrls: ['../civ-main/civ-main.component.css'],
})

export class CustomerContributionComponent {
  // @ts-ignore
  data;
  initialized: boolean;

  constructor(private detailScreensService: DetailScreensService) {
    this.initialized = false;
  }

  loadCustomerContribution() {
    if (this.initialized === false) {
      this.detailScreensService.getOldTabPage('klantbijdrage').subscribe((resp) => {
        this.data = resp;
        this.initialized = true;
        document.body.classList.remove('busy-cursor');
      });
    }
    document.body.classList.remove('busy-cursor');
  }

}
